var _path, _path2, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundmap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 236,
    viewBox: "0 0 467 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.361 25.3418C101.361 23.1327 103.152 21.3418 105.361 21.3418H444C456.702 21.3418 467 31.6392 467 44.3418V51.9073C467 59.087 461.18 64.9073 454 64.9073H105.361C103.152 64.9073 101.361 63.1164 101.361 60.9073V25.3418Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.361 213.386C101.361 215.596 103.152 217.386 105.361 217.386H444C456.702 217.386 467 207.089 467 194.386V186.821C467 179.641 461.18 173.821 454 173.821H105.361C103.152 173.821 101.361 175.612 101.361 177.821V213.386Z",
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.9092,
    y: 217.386,
    width: 196.045,
    height: 59.9026,
    rx: 29.9513,
    transform: "rotate(-90 67.9092 217.386)",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.8003,
    y: 235.28,
    width: 234.942,
    height: 38.8978,
    rx: 19.4489,
    transform: "rotate(-90 78.8003 235.28)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.227051,
    y: 89.0239,
    width: 109.692,
    height: 60.6805,
    rx: 30.3403,
    fill: "#D9D9D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundmap);
export default __webpack_public_path__ + "static/media/soundmap.47fdf75676f6f6681ec47f27aa47eca6.svg";
export { ForwardRef as ReactComponent };